var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "title": 'All Accounts',
      "items": [{
        label: 'Accounts'
      }]
    }
  }), _c('div', {
    staticClass: "bg-white p-0 my-3 rounded-lg shadow-sm"
  }, [_c('div', {
    staticClass: "flex px-4 py-3 justify-between items-center"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('svg', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "currentColor",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2a8 8 0 016.32 12.906l4.387 4.387a1 1 0 01-1.415 1.415l-4.387-4.387A8 8 0 1110 2zm0 2a6 6 0 100 12 6 6 0 000-12z"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filter,
      expression: "filter"
    }],
    staticClass: "p-2.5 pl-5 w-96 text-sm text not-italic border rounded-lg",
    attrs: {
      "placeholder": "Search Account Email"
    },
    domProps: {
      "value": _vm.filter
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debounceSearch.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value;
      }
    }
  }), _vm.filter ? _c('button', {
    staticClass: "absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 active:border",
    attrs: {
      "title": "Clear search"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" ✕ ")]) : _vm._e()]), _c('div', [_c('t-dropdown', {
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function (_ref) {
        var mousedownHandler = _ref.mousedownHandler,
          focusHandler = _ref.focusHandler,
          blurHandler = _ref.blurHandler,
          keydownHandler = _ref.keydownHandler;
        return _c('div', {
          staticClass: "flex z-50"
        }, [_c('button', {
          staticClass: "flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg",
          on: {
            "mousedown": mousedownHandler,
            "focus": focusHandler,
            "blur": blurHandler,
            "keydown": keydownHandler
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 mr-1 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z"
          }
        })]), _vm._v(" Filter "), _c('svg', {
          staticClass: "w-5 h-5 ml-1 text-gray-600 fill-current",
          attrs: {
            "viewBox": "0 0 20 20",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('polygon', {
          attrs: {
            "points": "9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8"
          }
        })]), _vm.dataBadge ? _c('div', {
          staticClass: "rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center"
        }, [_vm._v(" " + _vm._s(_vm.dataBadge) + " ")]) : _vm._e()])]);
      }
    }, {
      key: "default",
      fn: function (_ref2) {
        var hide = _ref2.hide,
          blurHandler = _ref2.blurHandler;
        return _c('div', {
          staticClass: "w-custom-user bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
        }, [_c('div', {
          staticClass: "block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100",
          attrs: {
            "role": "menuitem"
          }
        }, [_c('div', {
          staticClass: "flex justify-between"
        }, [_c('div', [_vm._v("Filter")]), _c('div', {
          on: {
            "click": hide
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 text-gray-800 dark:text-white cursor-pointer",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "none",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke": "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            "d": "M6 18 17.94 6M18 18 6.06 6"
          }
        })])])]), _c('div', {
          staticClass: "flex justify-between mb-3 mt-2"
        }, [_c('div', {
          staticClass: "w-full mr-2"
        }, [_c('label', {
          staticClass: "text-gray-600 font-semibold mb-3 mt-2"
        }, [_vm._v("Verification Status")]), _c('FilterComponent', {
          attrs: {
            "options": _vm.verificationStatusOptions,
            "defaultText": 'Select Verification Status'
          },
          model: {
            value: _vm.verificationStatus,
            callback: function ($$v) {
              _vm.verificationStatus = $$v;
            },
            expression: "verificationStatus"
          }
        })], 1), _c('div', {
          staticClass: "w-full ml-2"
        }, [_c('label', {
          staticClass: "text-gray-600 font-semibold mb-3 mt-2"
        }, [_vm._v("Status")]), _c('FilterComponent', {
          attrs: {
            "options": _vm.statusOptions,
            "defaultText": 'Select Status'
          },
          model: {
            value: _vm.itemStatus,
            callback: function ($$v) {
              _vm.itemStatus = $$v;
            },
            expression: "itemStatus"
          }
        })], 1)]), _c('div', {
          staticClass: "mt-3"
        }, [_c('button', {
          staticClass: "border bg-blue-500 px-4 py-2 text-white rounded-lg",
          on: {
            "click": function ($event) {
              return _vm.asyncFind();
            },
            "blur": blurHandler
          }
        }, [_vm._v(" Filter ")]), _c('button', {
          staticClass: "border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2",
          on: {
            "click": function ($event) {
              return _vm.reset();
            },
            "blur": blurHandler
          }
        }, [_vm._v("Reset")])])])]);
      }
    }])
  })], 1)]), _c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.users,
      "row-key": ['email', 'is_verified', 'created', 'last_login', 'status'],
      "current-page": _vm.currentPage,
      "isLoading": _vm.isLoading,
      "per-page": _vm.perPage
    },
    scopedSlots: _vm._u([{
      key: "header-register",
      fn: function (_ref3) {
        var column = _ref3.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "email",
      fn: function (_ref4) {
        var value = _ref4.value;
        return [_c('div', {
          staticClass: "flex lowercase items-center gap-1"
        }, [_vm._v(" " + _vm._s(value) + " ")])];
      }
    }, {
      key: "header-login",
      fn: function (_ref5) {
        var column = _ref5.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "is_verified",
      fn: function (_ref6) {
        var row = _ref6.row;
        return [_c('div', {
          staticClass: "px-2 py-1 text-center rounded-lg text-xs font-medium capitalize flex justify-start items-center"
        }, [row.verification_status === 'verified' ? _c('div', {
          staticClass: "bg-blue-100 text-blue-800 mr-2 p-1 px-2 rounded-lg"
        }, [_vm._v(" Verified ")]) : row.verification_status === 'unverified' ? _c('div', {
          staticClass: "bg-yellow-100 mr-2 text-yellow-800 p-1 px-2 rounded-lg"
        }, [_vm._v(" unverified ")]) : _vm._e(), row.verification_status === 'banned' ? _c('div', {
          staticClass: "bg-red-100 text-red-800 mr-2 p-1 px-2 rounded-lg"
        }, [_vm._v(" banned ")]) : _vm._e()])];
      }
    }, {
      key: "actions",
      fn: function (_ref7) {
        var row = _ref7.row;
        return [_c('t-dropdown', {
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function (_ref8) {
              var mousedownHandler = _ref8.mousedownHandler,
                focusHandler = _ref8.focusHandler,
                blurHandler = _ref8.blurHandler,
                keydownHandler = _ref8.keydownHandler,
                isShown = _ref8.isShown;
              return _c('div', {
                staticClass: "relative"
              }, [_c('button', {
                staticClass: "cursor-pointer focus:outline-none",
                class: {
                  ' text-gray-500 ': isShown
                },
                attrs: {
                  "id": "user-menu",
                  "aria-label": "User menu",
                  "aria-haspopup": "true"
                },
                on: {
                  "focus": function ($event) {
                    $event.stopPropagation();
                    return focusHandler.apply(null, arguments);
                  },
                  "blur": function ($event) {
                    $event.stopPropagation();
                    return blurHandler.apply(null, arguments);
                  },
                  "keydown": function ($event) {
                    $event.stopPropagation();
                    return keydownHandler.apply(null, arguments);
                  },
                  "click": function ($event) {
                    $event.stopPropagation();
                    return mousedownHandler.apply(null, arguments);
                  }
                }
              }, [_c('svg', {
                staticClass: "w-6 h-6 text-gray-800 dark:text-white",
                attrs: {
                  "aria-hidden": "true",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "width": "24",
                  "height": "24",
                  "fill": "none",
                  "viewBox": "0 0 24 24"
                }
              }, [_c('path', {
                attrs: {
                  "stroke": "currentColor",
                  "stroke-linecap": "round",
                  "stroke-width": "2",
                  "d": "M6 12h.01m6 0h.01m5.99 0h.01"
                }
              })])])]);
            }
          }, {
            key: "default",
            fn: function (_ref9) {
              var hide = _ref9.hide,
                blurHandler = _ref9.blurHandler;
              return _c('div', {}, [_c('button', {
                staticClass: "block text-left w-full px-3 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100",
                attrs: {
                  "role": "menuitem"
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return hide.apply(null, arguments);
                  },
                  "blur": blurHandler
                }
              }, [_c('router-link', {
                staticClass: "flex justify-start hover:no-underline hover:text-gray-500 text-gray-500 items-center w-full",
                attrs: {
                  "to": {
                    path: '/customers/detail/' + row.email
                  }
                }
              }, [_c('svg', {
                staticClass: "w-5 h-5 text-gray-500 dark:text-white",
                attrs: {
                  "aria-hidden": "true",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "width": "24",
                  "height": "24",
                  "fill": "currentColor",
                  "viewBox": "0 0 24 24"
                }
              }, [_c('path', {
                attrs: {
                  "fill-rule": "evenodd",
                  "d": "M4.998 7.78C6.729 6.345 9.198 5 12 5c2.802 0 5.27 1.345 7.002 2.78a12.713 12.713 0 0 1 2.096 2.183c.253.344.465.682.618.997.14.286.284.658.284 1.04s-.145.754-.284 1.04a6.6 6.6 0 0 1-.618.997 12.712 12.712 0 0 1-2.096 2.183C17.271 17.655 14.802 19 12 19c-2.802 0-5.27-1.345-7.002-2.78a12.712 12.712 0 0 1-2.096-2.183 6.6 6.6 0 0 1-.618-.997C2.144 12.754 2 12.382 2 12s.145-.754.284-1.04c.153-.315.365-.653.618-.997A12.714 12.714 0 0 1 4.998 7.78ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                  "clip-rule": "evenodd"
                }
              })]), _c('span', {
                staticClass: "ml-2 text-sm"
              }, [_vm._v(" View Detail ")])])], 1), _c('button', {
                staticClass: "text-left w-full flex justify-start items-center px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:no-underline hover:bg-gray-100 focus:outline-none focus:bg-gray-100",
                attrs: {
                  "role": "menuitem"
                },
                on: {
                  "click": [function ($event) {
                    $event.stopPropagation();
                    return hide.apply(null, arguments);
                  }, function ($event) {
                    return _vm.showModal(row, 'reset-password');
                  }],
                  "blur": blurHandler
                }
              }, [_c('i', {
                staticClass: "relative -left-1 fa-solid fa-key"
              }), _c('span', {
                staticClass: "ml-1.5 text-sm"
              }, [_vm._v(" Send Reset Password ")])]), _c('button', {
                staticClass: "block text-left w-full px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:no-underline hover:bg-gray-100 focus:outline-none focus:bg-gray-100",
                attrs: {
                  "role": "menuitem"
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return hide.apply(null, arguments);
                  },
                  "blur": blurHandler
                }
              }, [_c('i', {
                staticClass: "relative -left-1 fa-solid fa-envelope"
              }), _c('span', {
                staticClass: "ml-1 text-sm",
                class: row.is_verified || !row.roles.role_id ? 'opacity-50 pointer-events-none' : 'opacity-100',
                attrs: {
                  "disabled": row.is_verified || !row.roles.role_id
                },
                on: {
                  "click": function ($event) {
                    return _vm.showModal(row, 'verification');
                  }
                }
              }, [_vm._v(" Send Verification Email ")])])]);
            }
          }], null, true)
        })];
      }
    }, {
      key: "created",
      fn: function (_ref10) {
        var value = _ref10.value;
        return [_c('span', {
          staticClass: "text-sm"
        }, [_vm._v(_vm._s(_vm.formatDate(value).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(value).time))])];
      }
    }, {
      key: "last_login",
      fn: function (_ref11) {
        var value = _ref11.value;
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(value).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(value).time))])];
      }
    }, {
      key: "status",
      fn: function (_ref12) {
        var value = _ref12.value;
        return [_c('div', {
          staticClass: "text-center py-1 px-1.5 rounded-lg w-auto",
          class: {
            'bg-green-100': value === 'active',
            'bg-gray-100': value === 'inactive'
          }
        }, [_vm._v(" " + _vm._s(value) + " ")])];
      }
    }])
  }), _c('t-modal', {
    ref: "modalAction"
  }, [_c('div', {
    staticClass: "text-sm flex-col justify-center items-center text-center"
  }, [_c('p', {
    staticClass: "text-base font-semibold text-gray-900 mb-2"
  }, [_vm._v("Are you sure?")]), _c('div', {
    staticClass: "text-base text-gray-500"
  }, [_vm._v(" You will send "), _vm.modalActionType === 'reset-password' ? _c('span', [_vm._v("reset password")]) : _vm.modalActionType === 'verification' ? _c('span', [_vm._v("email verification")]) : _vm._e(), _vm._v(" to ")]), _c('p', {
    staticClass: "text-gray-900"
  }, [_vm._v(_vm._s(_vm.selectedUser.email))]), _c('div', {
    staticClass: "mt-2 flex justify-center items-center"
  }, [_c('button', {
    staticClass: "bg-blue-700 px-2.5 py-2 text-white rounded-lg",
    class: _vm.loadingBtnModal ? 'opacity-50 pointer-events-none' : '',
    attrs: {
      "disabled": _vm.loadingBtnModal
    },
    on: {
      "click": _vm.handleModalAction
    }
  }, [_vm._v(" " + _vm._s(_vm.loadingBtnModal ? 'Loading ...' : 'Save') + " ")]), _c('button', {
    staticClass: "bg-white border ml-2 px-2.5 py-2 text-gray-500 rounded-lg",
    on: {
      "click": _vm.cancelBtn
    }
  }, [_vm._v("Cancel")])])])]), _vm.totalRows / _vm.perPage > 1 ? _c('div', {
    staticClass: "flex justify-between ml-1 px-3 items-start mt-3"
  }, [_c('div', {
    staticClass: "font-semibold mt-1"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }